import { useState, useEffect } from 'react'
import { getTraningAPI } from '../services/certificate'

function UseTypeCourse() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTraningAPI()
      if (!result) return

      const newData = result.result.length > 0 && result.result.map((d, i) => {
        return { value: d.id, label: d.course }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseTypeCourse
